import { SIGN_UP_INPUT_FIELD_ERROR } from "@faire/retailer-visitor-shared/consts/sign-up-input-field-error";
import { isValidEmail } from "@faire/retailer-visitor-shared/lib/validation";
import { getIsProduction } from "@faire/retailer-visitor-shared/serialized-data/getEnvName";
export var isInvalidEmail = function(email) {
    if (!email || email.length === 0) {
        return SIGN_UP_INPUT_FIELD_ERROR.MISSING;
    }
    if (!isValidEmail(email)) {
        return SIGN_UP_INPUT_FIELD_ERROR.INVALID_VALUE;
    }
    return false;
};
export var isFaireEmail = function(email) {
    if (!email || email.length === 0) {
        return SIGN_UP_INPUT_FIELD_ERROR.MISSING;
    }
    if (!isValidEmail(email) || getIsProduction() && !email.includes("+") && email.trim().endsWith("@faire.com")) {
        return SIGN_UP_INPUT_FIELD_ERROR.INVALID_VALUE;
    }
    return false;
};
